const resourceInfo = state => state.resourceInfo
const oaQuery = state => state.oaQuery
const oaZjInfo = state => state.oaZjInfo

export default {
  resourceInfo,
  oaQuery,
  oaZjInfo
}
